export const fieldMasks = [
  ['none', 'Sem máscara'],
  ['cep', 'CEP — 00000-000'],
  ['cpf', 'CPF — 000.000.000-00'],
  ['cnpj', 'CNPJ — 00.000.000/0000-00'],
  ['phone', 'Telefone com DDD — fixo ou celular'],
  ['mobile', 'Celular com DDD — (00) 00000-0000'],
  ['landline', 'Telefone fixo com DDD — (00) 0000-0000'],
  ['digits', 'Somente números'],
];
export const maskLengths = { cep: 9, cpf: 14, cnpj: 18, phone: 15, mobile: 15, landline: 14 };
export function fieldMask(field) {
  if (!['text', 'tel'].includes(field.type)) return 'none';
  if (field.mask) return field.mask;
  const name = `${field.id} ${field.label}`
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/_/g, ' ')
    .toLowerCase();
  if (/\b(cep|postal code|zipcode|zip code)\b/.test(name)) return 'cep';
  if (/\bcnpj\b/.test(name)) return 'cnpj';
  if (/\bcpf\b/.test(name)) return 'cpf';
  if (/\b(celular|mobile)\b/.test(name)) return 'mobile';
  if (/\b(fixo|landline)\b/.test(name)) return 'landline';
  if (field.type === 'tel' || /\b(telefone|phone|fone|whatsapp)\b/.test(name)) return 'phone';
  return 'none';
}
export function changeFieldType(field, type) {
  const updated = { ...field, type };
  if (!['text', 'textarea', 'email', 'tel'].includes(type)) delete updated.max_length;
  if (!['text', 'tel'].includes(type)) delete updated.mask;
  if (['select', 'radio'].includes(type))
    updated.options = updated.options?.length ? updated.options : [''];
  else delete updated.options;
  if (type !== 'number') {
    delete updated.min;
    delete updated.max;
  }
  if (type === 'file') {
    updated.file_types = updated.file_types || 'image_pdf';
    updated.max_kb = updated.max_kb || 5120;
  } else {
    delete updated.file_types;
    delete updated.max_kb;
  }
  return updated;
}
